module.exports = __webpack_public_path__ + "static/61825809_1286745774823825_5400234257262051328_o_optimized-7aa19f737fd8ba99148a9118e0b6fce3.jpg";